<template>
    <div v-if="showModal">
        <b-modal
                v-model="showModalLocal"
                :title="'Добавление брони (профкурорт только)'"
                class="modal-primary"
                size="md"
                ok-variant="primary"
                @hide.prevent
                @ok="handleOk"
                @cancel="handleCancel"
                @close="handleCancel"
                ref="my-modal"
        >
            <form  @submit.prevent="handleSubmit">

                <b-form-group
                    label="Идентификатор брони профкурорта"
                    description="Идентификатор существующей брони профкурорта в виде 61577/09-2019"
                    :state="validateState('externId')"
                    :invalid-feedback="veeErrors.first('externId')"
                >

                    <b-form-input type="text"
                                  v-model="externId"
                                  v-validate="{max:32,required:true, regex:/^\d{1,6}\/\d{2}-\d{4}(?:\/\d+)?$/}"
                                  id="externId"
                                  name="externId"
                                  data-vv-as="'Идентификатор брони'"
                                  :state="validateState('externId')"
                    ></b-form-input>

                </b-form-group>

            </form>

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Сохранить
                </b-button>
            </template>
        </b-modal>
    </div>
</template>


<script>
    import { functions } from '@/functions';
    //import { functions_loaders } from '@/functions_loaders';
    //import {CONSTANTS} from '@/constants'

    export default {
        name: 'BookingCreateDialogProfkurort',
        mixins: [functions],
        data: function () {
            return {
                bookerId:1, // профкурорт
                externId:null,
            };
        },
        model: {
            prop: "showModal",
            event: "hide"
        },
        props: {
            showModal: [Number, Boolean],
            voucherx: Object,
            bookingsx: Array,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", false);
            },
            handleOk: function () {
                this.doOk();
            },
            handleSubmit: function () {
                this.doOk();
            },
            doOk:function () {
                this.console_log('BookingCreateDialogProfkurort: doOk');
                this.$validator.validateAll().then((result) => {
                    this.console_log('ok')
                        if (!result) {
                            this.console_log('ok1')
                            return false;
                        }
                        this.console_log('ok2')
                        this.appendBooking(this.voucherx.id, this.bookerId, this.externId);
                        this.$emit("hide", false);
                    }, (error) => {
                        this.console_log('error')
                    }
                ).catch(()=>{
                    this.console_log('catch')
                });
            },
            appendBooking: function (voucher_id, booker_id, external_id) {
                this.httpPrepare();
                this.$http.post(this.apiurl('booking/append'), {voucher_id:voucher_id, booker_id: booker_id, external_id:external_id}).then(function (response) {
                    response = this.httpSuccess(response);
                    if (response.result === 'success') {
                        this.bookingsx.push(response.payload);
                    }
                    else {
                        this.error_log(response.error);
                    }
                }, this.httpError);
            }
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.showModal
                },
                set: function (newValue) {}
            }
        },
        created: function() {
        },
        mounted: function() {
        },
        updated: function() {
        },
    }
</script>
